import React from 'react';
import CommonTable from '../../../common/table/CommonTable';
import { SALES_INCL_VAT, TOTAL_COLUMN } from '../standard/StandardReportConsts';
import MoneyFormat from '../../../common/MoneyFormat';
import { TrendingDown, TrendingUp } from '@material-ui/icons';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';

const ComparisonTable = ({ comparisonData }) => {
  const [dateRange1, dateRange2] = comparisonData;
  
  const findItemWithTotal = (dateRange) =>
    dateRange[0].find((item) => Object.values(item).some((value) => value === TOTAL_COLUMN) && item[SALES_INCL_VAT]);
  
  const findItem = (dateRange) => {
    const item = findItemWithTotal(dateRange);
    return item && item[SALES_INCL_VAT];
  };
  
  const dateRange1Value = findItem(dateRange1);
  const dateRange2Value = findItem(dateRange2);
  
  if (dateRange1Value === undefined || dateRange2Value === undefined) {
    return null;
  }
  
  const calculateDifference = (value1, value2) => (value2 - value1).toFixed(5);
  const calculatePercentageChange = (value1, value2) => (((value2 - value1) / value1) * 100).toFixed(2);
  const differenceNetSalesInclVat = calculateDifference(dateRange1Value, dateRange2Value);
  const differenceNetSalesInclVatPercentage = calculatePercentageChange(dateRange1Value, dateRange2Value);
  
  const tableData = [
    {
      dateFromTo1: `${dateRange1[1].date.dateFrom} - ${dateRange1[1].date.dateTo}`,
      dateFromTo2: `${dateRange2[1].date.dateFrom} - ${dateRange2[1].date.dateTo}`,
      difference: differenceNetSalesInclVat,
      differencePercentage: differenceNetSalesInclVatPercentage,
    },
  ];
  
  const tableConfig = [
    {
      header: `Period 1`,
      value: () => <MoneyFormat value={dateRange1Value} />,
    },
    {
      header: `Period 2`,
      value: () => <MoneyFormat value={dateRange2Value} />,
    },
    {
      header: <FormattedMessage id="difference" defaultMessage="Difference" />,
      value: (data) => <MoneyFormat value={data.difference} />,
    },
    {
      header: <FormattedMessage id="change" defaultMessage="Change" />,
      value: ({ differencePercentage }) => {
        const isPositiveChange = differencePercentage > 0;
        const color = isPositiveChange ? 'green' : 'red';
        return (
          <Box display="flex" justifyContent="center" alignItems="center">
            {`${differencePercentage}%`}
            {isPositiveChange ? <TrendingUp style={{ color }} /> : <TrendingDown style={{ color }} />}
          </Box>
        );
      },
    },
  ];
  
  return (
    <CommonTable
      data={tableData}
      title={<FormattedMessage id="menu.main.reports" defaultMessage="Reports" />}
      tableConfig={tableConfig}
    />
  );
};

export default ComparisonTable;
